export default "__VITE_ASSET__BUOJpCnz__"